// https://www.freakyjolly.com/react-material-ui-datepicker-and-timepicker-tutorial/#.X_JJe9gzZPY
// https://next.material-ui.com/components/date-time-picker/
// https://codesandbox.io/s/xvzollx44q?file=/demo.js
// https://material-ui.com/components/pickers/
// https://material-ui-pickers.dev/demo/datepicker

// • disabled: Takes boolean to set the disabled state of Datepicker.
// • disableFuture: Set to true to disable all future dates.
// • disablePast: Disable previous/past dates from today.
// • disableToolbar: Hide toolbar and show only date/time views.
// • format: Format of the date string eg DD/MM/YYYY
// • maxDate: Max selectable date.
// • minDate: Min selectable date.
// • open: Controlled picker open state.
// • openTo: The first view to show in DatePicker; "date" | "year" | "month".
// • orientation: Force rendering in particular orientation;”portrait“(default) | “landscape“.
// • readOnly: Make picker read-only

import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";
import TextError from "./TextError";

import DateFnsUtils from "@date-io/date-fns";
import "date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { Label } from "@material-ui/icons";

const startAdornment = (isDisplay) => ({
  startAdornment: (
    <InputAdornment position="start">
      <PriorityHighIcon style={{ color: "red", display: isDisplay }} />
    </InputAdornment>
  ),
});

function DatePicker(props) {
  // console.log("DatePicker Props", props);

  const [selectedDate, setSelectedDate] = React.useState(
    // new Date("2014-08-18T21:11:54")
    // new Date()
    null
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
    console.log("Date:", date);
  };

  const { classes } = props;
  const [isDisplay, setisDisplay] = useState("none");
  const {
    label,
    name,
    field,
    errorobj,
    touched,
    value,
    onChange,
    blur,
    formikobj,
    placeholder,
    views,
    disableToolbar,
    ...rest
  } = props;
  // console.log("Input: ", props);
  const myBlur = () => {
    // console.log('Blur',errorobj);
  };

  return (
    <div>
      <Field id={name} name={name} label={label} value={value} {...rest}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            {/* {meta.touched && meta.error && (
                <PriorityHighIcon style={{ color: "red", display: "block" ,position:'absolute',bottom:'10px'}} />
              )} */}

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                {...rest}
                {...field}
                id={name}
                name={name}
                placeholder={placeholder}
                label={label}
                disableToolbar={disableToolbar}
                autoOk
                variant="inline"
                views={views}
                // views={["year", "month", "date"]}
                format="dd/MM/yyyy"
                margin="normal"
                // value={value}
                // onChange={onChange}
                value={selectedDate}
                onChange={(value) => {
                  handleDateChange(value);
                  formikobj.setFieldValue(`${name}`, value);
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>

            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
}

export default DatePicker;
